
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"22","viewBox":"0 0 24 22"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12 0C5.372 0 0 4.573 0 10.213c0 2.39.932 4.591 2.427 6.164L0 22l7.563-2.26C17.058 22.338 24 16.489 24 10.213 24 4.573 18.628 0 12 0z","fill":"#3F51B5"}})])
          )
        }
      }
    